/* eslint-disable */
import React from 'react'
import http from '../Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import {Checkbox, message} from 'antd'
import jMoment from 'moment-jalaali'
import $ from 'jquery'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import Pageing from '../Pagination/pageing'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {GoogleApiWrapper, Map, Marker} from 'google-maps-react'
import RETAIL from '../BaseComponent/RETAIL'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import {accounting} from 'accounting'
import Sort from '../Pagination/Sort'
import CRM from '../BaseComponent/CRM'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import 'react-tabs/style/react-tabs.css'
import {genderType} from '../utils/convert'
import Loader from '../loaders/loader'
import SearchCustomer from '../BaseComponent/SearchCustomer'
import {voip} from '../Reports/call/voip'
import {editOrder, orderInfo} from '../../lib/path'

class ReportCustomerCard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: 0,
      customerCode: '',
      sizeEditedAddress: 10,
      numberEditedAddress: 1,
      listEditedAddress: [],
      sizeTransaction: 10,
      numberTransaction: 1,
      listTransaction: [],
      listInvoice: [],
      numberInvoice: 1,
      sizeInvoice: 10,
      aggregationInvoice: {},
      sortByInvoice: 'registerDate_desc',
      numberDeliveryPack: 1,
      sizeDeliveryPack: 10,
      deliveryPack: [],
      aggregationDeliveryPack: {},
      sortByDeliveryPack: 'planDate_Desc,planTimeFrom_Asc,invoiceNum_Asc',
      colored: [],
      rfml: [],
      numberRfml: 1,
      sizeRfml: 10,
      sortByRfml: '',
      noBuy: [],
      numberNoBuy: 1,
      sizeNoBuy: 10,
      numberCrm: 1,
      sizeCrm: 10,
      crm: [],
      editableMediaList: [],
      editableCategoryList: [],
      editableSubjectList: [],
      editableDefinitionList: [],
      editablePriorityList: [],
      editableStatusList: [],
      detailsList: [],
      selectedRow: [],
      sortByCrm: 'registrationTime_desc',
      sortEditedAddress: 'editionTime_desc',
      showProfile: false,
      profile: {},
      customerInvoice: {},
      customerPurchase: {},
      customerCancel: {},
      customerCurrent: {},
      numberPurchased: 1,
      sizePurchased: 10,
      listPurchased: [],
      sortTransaction: [],
      sortByTransaction: 'registerDate_desc',
      sortByPurchased: 'itemCount_desc',
      content: 'overView'
    }
  }

  componentDidMount() {
    let urlParams = new URLSearchParams(window.location.search)
    let customerCode = urlParams.get('customerCode') === null ? '' : urlParams.get('customerCode')
    if (customerCode !== '') {
      this.setState({
        customerCode,
        loading: true,
        filteredProfile: false,
        filteredCrm: false,
        filteredInvoice: false,
        filteredAddress: false,
        filteredPurchase: false,
        filteredTransaction: false,
        filteredDeliveryPack: false
      })
      // this.getEditedAddress(customerCode)
      // this.getTransactionCustomer(customerCode)
      // this.getInvoice(customerCode)
      // this.getDeliveryPack(customerCode)
      // this.crm(customerCode)
      this.getProfile(customerCode).then(() => {
        this.setState({
          loading: false,
          filtered: true,
          filteredProfile: true
        })
      })
      // this.getPurchasedProduct(customerCode)
    }

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.numberEditedAddress !== this.state.numberEditedAddress) {
      this.getEditedAddress(this.state.customerCode)
    }
    if (prevState.sizeEditedAddress !== this.state.sizeEditedAddress) {
      this.setState(
        {
          numberEditedAddress: 1
        },
        () => {
          this.getEditedAddress(this.state.customerCode)
        }
      )
    }
    if (prevState.sortEditedAddress !== this.state.sortEditedAddress) {
      this.getEditedAddress(this.state.customerCode)
    }
    if (prevState.numberTransaction !== this.state.numberTransaction) {
      this.getTransactionCustomer(this.state.customerCode)
    }
    if (prevState.sortByTransaction !== this.state.sortByTransaction) {
      this.getTransactionCustomer(this.state.customerCode)
    }
    if (prevState.sizeTransaction !== this.state.sizeTransaction) {
      this.setState(
        {
          numberTransaction: 1
        },
        () => {
          this.getTransactionCustomer(this.state.customerCode)
        }
      )
    }
    if (prevState.numberInvoice !== this.state.numberInvoice) {
      this.getInvoice(this.state.customerCode)
    }
    if (prevState.sizeInvoice !== this.state.sizeInvoice) {
      this.setState(
        {
          numberInvoice: 1
        },
        () => {
          this.getInvoice(this.state.customerCode)
        }
      )
    }
    if (prevState.sortByInvoice !== this.state.sortByInvoice) {
      this.getInvoice(this.state.customerCode)
    }
    if (prevState.numberDeliveryPack !== this.state.numberDeliveryPack) {
      this.getDeliveryPack(this.state.customerCode)
    }
    if (prevState.sizeDeliveryPack !== this.state.sizeDeliveryPack) {
      this.setState(
        {
          numberDeliveryPack: 1
        },
        () => {
          this.getDeliveryPack(this.state.customerCode)
        }
      )
    }
    if (prevState.sortByDeliveryPack !== this.state.sortByDeliveryPack) {
      this.getDeliveryPack(this.state.customerCode)
    }
    if (prevState.deliveryPack !== this.state.deliveryPack) {
      let deliveryPack = this.state.deliveryPack
      let colored = this.state.colored
      for (let i in colored) {
        let findIndex = deliveryPack.findIndex((items) => items.invoice.invoiceId === colored[i])
        if (findIndex >= 0) {
          deliveryPack[findIndex].colored = true
        }
      }
      this.setState({
        deliveryPack
      })
    }

    if (prevState.numberRfml !== this.state.numberRfml) {
      this.getRfml(this.state.customerCode)
    }
    if (prevState.sortByRfml !== this.state.sortByRfml) {
      this.getRfml(this.state.customerCode)
    }
    if (prevState.numberCrm !== this.state.numberCrm) {
      this.crm(this.state.customerCode)
    }
    if (prevState.sizeCrm !== this.state.sizeCrm) {
      this.setState(
        {
          numberCrm: 1
        },
        () => {
          this.crm(this.state.customerCode)
        }
      )
    }
    if (prevState.sortByCrm !== this.state.sortByCrm) {
      this.crm(this.state.customerCode)
    }

    if (prevState.numberPurchased !== this.state.numberPurchased) {
      this.getPurchasedProduct(this.state.customerCode)
    }
    if (prevState.sizePurchased !== this.state.sizePurchased) {
      this.setState(
        {
          numberPurchased: 1
        },
        () => {
          this.getPurchasedProduct(this.state.customerCode)
        }
      )
    }
    if (prevState.sortByPurchased !== this.state.sortByPurchased) {
      this.getPurchasedProduct(this.state.customerCode)
    }
  }

  getProfile = (customerCode) => {
    return http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_CUSTOMER_CLUB_DETAIL}`, {
        params: {
          customerCode
        }
      })
      .then((res) => {
        if (res.data.error === null) {
          this.setState({
            profile: res.data.object.result[0].customer,
            showProfile: true,
            customerInvoice: res.data.object.result[0].invoice,
            customerPurchase: res.data.object.result[0].purchase,
            customerCurrent: res.data.object.result[0].current,
            customerCancel: res.data.object.result[0].cancel,
            festival: res.data.object.result[0].festival,
            deal: res.data.object.result[0].deal,
            allGiftAmount: res.data.object.result[0].allGiftAmount,
            usedGiftAmount: res.data.object.result[0].usedGiftAmount,
            notSuppliedItemCount: res.data.object.result[0].notSuppliedItemCount,
            notSuppliedItemPercent: res.data.object.result[0].notSuppliedItemPercent
          })
        } else {
          this.setState({
            showProfile: false
          })
        }
      })
      .catch(() => {
        this.setState({
          showProfile: false
        })
      })
  }

  getEditedAddress = (customerCode) => {
    let filter = {
      pageSize: this.state.sizeEditedAddress,
      pageNumber: this.state.numberEditedAddress,
      customerCode,
      export: false,
      sortBy: this.state.sortEditedAddress
    }
    return http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_CUSTOMER_CLUB_ADDRESS}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            listEditedAddress: response.data.object.result,
            countAllEditedAddress: response.data.object.countAll,
            sortEditedAddressData: [
              {
                name: 'ردیف',
                value: 'supplyDate',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'آدرس',
                value: 'address',
                sorted: false,
                direction: null,
                sortable: true
              },
              {
                name: 'تعداد ارسال',
                value: 'addressCount',
                sorted: false,
                direction: null,
                sortable: true
              }
            ]
          })
        } else {
          this.setState({
            listEditedAddress: []
          })
        }
      })
  }
  getSortEditedAddress = (sortEditedAddress) => {
    this.setState({
      sortEditedAddress
    })
  }

  getPageNumberEditedAddress = (numberEditedAddress) => {
    this.setState({
      numberEditedAddress
    })
  }

  showLocationEditedAddress = (latitude, longitude, recipientName) => {
    this.setState({
      latitude,
      longitude,
      recipientName,
      modalEditedAddress: !this.state.modalEditedAddress
    })
  }

  confirm = (id, recipientName) => {
    this.setState({
      id,
      recipientName,
      confirmModal: !this.state.confirmModal
    })
  }

  confirmOk = () => {
    let {id} = this.state
    let data = {
      id
    }
    http.post(`${RETAIL.RETAIL_COMPANY_EDITEDADDRESSES_CONFIRM}`, data, {}).then((response) => {
      if (response.data.error === null) {
        message.success('آدرس با موفقیت ثبت شد')
        let driverId = this.state.driverId
        this.setState({
          confirmModal: false
        })
        this.getEditedAddress(this.state.customerCode)
      } else {
      }
    })
  }

  getTransactionCustomer = (customerCode) => {
    let filter = {
      pageSize: this.state.sizeTransaction,
      pageNumber: this.state.numberTransaction,
      customerCode,
      export: false,
      sortBy: this.state.sortByTransaction,
      sortAscending: 0
    }
    return http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_CUSTOMER_TRANSACTION_SINGLE}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          this.setState({
            listTransaction: response.data.object.result,
            countAllTransaction: response.data.object.countAll,
            sortTransaction: [
              {
                name: 'ردیف',
                value: 'supplyDate',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'تاریخ ثبت',
                value: 'registerDate',
                sorted: false,
                direction: null,
                sortable: true
              },
              {
                name: 'شناسه تراکنش',
                value: 'transactionId',
                sorted: false,
                direction: null,
                sortable: true
              },
              {
                name: 'شناسه فاکتور',
                value: 'invoiceId',
                sorted: false,
                direction: null,
                sortable: true
              },
              {
                name: 'شناسه پرداخت',
                value: 'paymentId',
                sorted: false,
                direction: null,
                sortable: true
              },
              {
                name: 'نوع پرداخت',
                value: 'paymentMethodName',
                sorted: false,
                direction: null,
                sortable: true
              },
              {
                name: 'شرح پرداخت',
                value: 'paymentDescription',
                sorted: false,
                direction: null,
                sortable: true
              },
              {
                name: 'مبلغ تراکنش',
                value: 'amount',
                sorted: false,
                direction: null,
                sortable: true
              },
              {
                name: 'مانده',
                value: 'amountSum',
                sorted: false,
                direction: null,
                sortable: true
              }
            ]
          })
        } else {
          this.setState({
            listTransaction: [],
            countAllTransaction: 0
          })
        }
      })
  }

  getPageNumberTransactionCustomer = (numberTransaction) => {
    this.setState({numberTransaction})
  }
  getSortTransaction = (sortByTransaction) => {
    this.setState({
      sortByTransaction
    })
  }

  getInvoice = (customerCode) => {
    let filter = {
      pageSize: this.state.sizeInvoice,
      pageNumber: this.state.numberInvoice,
      userCode: customerCode,
      export: false,
      sortBy: this.state.sortByInvoice
    }
    return http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_INVOICE_MASTER}/aggregation`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            listInvoice: response.data.object.result,
            countAllInvoice: response.data.object.countAll,
            aggregationInvoice: response.data.object.aggregation,
            showInvoiceCols: true,
            sortInvoiceData: [
              {
                name: 'ردیف',
                value: 'supplyDate',
                sorted: false,
                direction: null,
                sortable: false
              },
              // {
              //     name: "شناسه فاکتور",
              //     value: "invoiceId",
              //     sorted: false,
              //     direction: null,
              //     sortable: true
              // },
              {
                name: 'شماره فاکتور',
                value: 'invoiceNum',
                sorted: false,
                direction: null,
                sortable: true
              },

              {
                name: 'تحویل گیرنده',
                value: 'recipientName',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'موبایل تحویل گیرنده',
                value: 'mobile',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'وضعیت تایید',
                value: 'alternativeUnitTitle',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'وضعیت پرداخت',
                value: 'alternativeUnitTitle',
                sorted: false,
                direction: null,
                sortable: false
              },

              {
                name: 'تاریخ ثبت',
                value: 'registerDate',
                sorted: false,
                direction: null,
                sortable: true
              },
              {
                name: 'تاریخ تایید',
                value: 'confirmDate',
                sorted: false,
                direction: null,
                sortable: true
              },
              {
                name: 'پرداخت در محل',
                value: 'confirmDate',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'مبلغ کل',
                value: 'invoiceTotalAmount',
                sorted: false,
                direction: null,
                sortable: true
              },
              {
                name: 'تخفیف وبسایت',
                value: 'invoiceWebsiteDiscountAmount',
                sorted: false,
                direction: null,
                sortable: true
              },
              {
                name: 'تخفیف تامین کننده',
                value: 'invoiceProviderDiscountAmount',
                sorted: false,
                direction: null,
                sortable: true
              },
              {
                name: 'قابل پرداخت',
                value: 'invoicePayableAmount',
                sorted: false,
                direction: null,
                sortable: true
              },
              {
                name: 'آدرس',
                value: 'address',
                sorted: false,
                direction: null,
                sortable: true
              },
              {
                name: 'جزییات فاکتور',
                value: 'confirmDate',
                sorted: false,
                direction: null,
                sortable: false
              }
            ]
          })
        } else {
          this.setState({
            listInvoice: [],
            loading: false
          })
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }

  getPageNumberInvoice = (numberInvoice) => {
    this.setState({numberInvoice})
  }
  getSortInvoice = (sortByInvoice) => {
    this.setState({
      sortByInvoice
    })
  }

  getDeliveryPack = (customerCode) => {
    let filter = {
      userCode: customerCode,
      export: false,
      pageSize: this.state.sizeDeliveryPack,
      pageNumber: this.state.numberDeliveryPack,
      sortBy: this.state.sortByDeliveryPack
    }
    return http
      .get(REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_MASTER + '/aggregation', {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            deliveryPack: response.data.object.result,
            aggregationDeliveryPack: response.data.object.aggregation,
            countAllDeliveryPack: response.data.object.countAll,
            sortDataDeliveryPack: [
              {
                name: 'ردیف',
                value: 'supplyDate',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: this.props.subDispatch ? 'تاریخ توزیع' : 'تاریخ تحویل',
                value: this.props.subDispatch ? 'dispatchPlanDate' : 'planDate',
                sorted: false,
                direction: null,
                sortable: true
              },
              {
                name: this.props.subDispatch ? 'بازه توزیع' : 'بازه تحویل',
                value: this.props.subDispatch ? 'dispatchPlanTimeFrom' : 'planTimeFrom',
                sorted: false,
                direction: null,
                sortable: true
              },
              {
                name: 'زمان تحویل',
                value: 'dispatchDate',
                sorted: false,
                direction: null,
                sortable: true
              },
              {
                name: 'شناسه فاکتور',
                value: 'invoiceId',
                sorted: false,
                direction: null,
                sortable: true
              },
              {
                name: 'شماره فاکتور',
                value: 'invoiceNum',
                sorted: false,
                direction: null,
                sortable: true
              },
              {
                name: 'خریدار',
                value: 'buyerName',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'کد مشتری',
                value: 'userCode',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'تحویل گیرنده',
                value: 'recipientName',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'آدرس',
                value: 'mobile',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'موبایل',
                value: 'mobile',
                sorted: false,
                direction: null,
                sortable: false
              },

              {
                name: 'وضعیت پرداخت',
                value: 'alternativeUnitTitle',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'پرداخت در محل',
                value: 'confirmDate',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'رساننده',
                value: 'driverName',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'کد اتومبیل',
                value: 'carCode',
                sorted: false,
                direction: null,
                sortable: false
              },

              {
                name: 'قابل پرداخت',
                value: 'payableAmount',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'پرداخت نقدی',
                value: 'payableAmount',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'پرداخت کارتخوان',
                value: 'payableAmount',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'پرداخت از قبل',
                value: 'payableAmount',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'حالت',
                value: 'lastState',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'نوع تحویل',
                value: 'lastState',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'جزییات',
                value: 'lastState',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'پرداختی',
                value: 'lastState',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'ویرایش',
                value: 'lastState',
                sorted: false,
                direction: null,
                sortable: false
              }
            ]
          })
        } else {
          this.setState({
            loading: false,
            deliveryPack: []
          })
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }

  getPageNumberDeliveryPack = (numberDeliveryPack) => {
    this.setState({numberDeliveryPack})
  }

  getSortDeliveryPack = (sortByDeliveryPack) => {
    this.setState({
      sortByDeliveryPack
    })
  }

  getPurchasedProduct = (customerCode) => {
    let filter = {
      customerCode: customerCode,
      export: false,
      pageSize: this.state.sizePurchased,
      pageNumber: this.state.numberPurchased,
      sortBy: this.state.sortByPurchased
    }
    return http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_CUSTOMER_CLUB_PRODUCT}`, {
        params: filter
      })
      .then((res) => {
        if (res.data.error === null) {
          this.setState({
            listPurchased: res.data.object.result,
            countAllPurchased: res.data.object.countAll,
            sortDataPurchased: [
              {
                name: 'ردیف',
                value: 'supplyDate',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'عنوان',
                value: 'title',
                sorted: false,
                direction: null,
                sortable: true
              },
              {
                name: 'تعداد',
                value: 'itemCount',
                sorted: false,
                direction: null,
                sortable: true
              },
              {
                name: 'مبلغ',
                value: 'payableAmount',
                sorted: false,
                direction: null,
                sortable: true
              }
            ]
          })
        }
      })
  }

  getSortPurchasedProduct = (sortByPurchased) => {
    this.setState({
      sortByPurchased
    })
  }

  getPageNumberPurchased = (numberPurchased) => {
    this.setState({
      numberPurchased
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }
  convertState = (x, y) => {
    if (x == -100) {
      x = 'کنسل'
      // return x;
    } else if (x == -75) {
      x = 'مرجوعی'
      // return x;
    } else if (x == -50) {
      x = 'بازگشتی'
      // return x;
    } else if (x == 100) {
      x = 'تخصیص مجدد'
      // return x;
    } else if (x == -1) {
      x = 'تخصیص داده نشده'
      // return x;
    } else if (x === 1) {
      x = 'فعال'
      // return x;
    } else if (x == 5) {
      x = 'اول فعال'
      // return x;
    } else if (x == 10) {
      x = 'شروع شده'
      // return x;
    } else if (x == 18) {
      x = 'تسویه نشده'
      // return x;
    } else if (x == 20) {
      x = 'تسویه شده'
    }

    if (y) {
      y = 'تخصیص مجدد'
    } else {
      y = ''
    }

    return y == '' ? x : y + ' - ' + x
  }
  goBeroozresan = (invoiceId) => {
    window.open(editOrder({invoiceId}), '_blank')
    let colored = this.state.colored
    colored.push(invoiceId)
    this.setState({
      colored
    })
    let findRow = this.state.deliveryPack.findIndex((items) => items.invoice.invoiceId === invoiceId)
    let deliveryPackData = this.state.deliveryPack
    deliveryPackData[findRow].colored = true
    this.setState({
      deliveryPack: deliveryPackData
    })
  }
  openSign = (num) => {
    sessionStorage.setItem('index', num)
    this.setState({
      modal: !this.state.modal
    })
    let {deliveryPack} = this.state

    var deliveryPackId = deliveryPack[num].deliveryPackId
    let data = {
      deliveryPackId: deliveryPackId
    }
    http
      .post(`${RETAIL.RETAIL_COMPANY_DELIVERYPACK_SIGN}`, data, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            urlSign: `data:image/png;base64,${response.data.object}`
          })
        }
      })
      .catch((error) => {})
  }
  toggle = () => {
    this.setState({
      modal: !this.state.modal
    })
  }

  crm = (customerCode) => {
    let filter = {
      customerCode,
      export: false,
      pageSize: this.state.sizeCrm,
      pageNumber: this.state.numberCrm,
      sortBy: this.state.sortByCrm
    }
    return http
      .get(`${CRM.CRM_CONTACT_MASTER_LIST}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          this.setState({
            crm: response.data.object.result,
            countCrm: response.data.object.countAll,
            crmSortData: [
              {
                name: 'ردیف',
                value: 'id',
                sorted: false,
                direction: null,
                sortable: false
              },

              {
                name: 'نام مشتری',
                value: 'name',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: ' جنسیت',
                value: 'messageContent',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'کد مشتری',
                value: 'customerCode',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'موبایل مشتری',
                value: 'mobile',
                sorted: false,
                direction: null,
                sortable: false
              },

              {
                name: 'شناسه فاکتور',
                value: 'invoiceId',
                sorted: true,
                direction: null,
                sortable: true
              },

              {
                name: 'شماره فاکتور',
                value: 'invoiceNum',
                sorted: true,
                direction: null,
                sortable: true
              },
              {
                name: 'زمان ثبت',
                value: 'registrationTime',
                sorted: true,
                direction: null,
                sortable: true
              },
              {
                name: 'کاربر ثبت کننده',
                value: 'operatorName',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'زمان آخرین تغییر',
                value: 'lastChangeTimeStamp',
                sorted: true,
                direction: null,
                sortable: true
              },
              {
                name: 'آخرین وضعیت',
                value: 'contactStatusName',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'تاریخچه تغییرات',
                value: 'changeHistory',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'پردازش',
                value: 'process',
                sorted: false,
                direction: null,
                sortable: false
              },
              {
                name: 'وضعیت مشاهده',
                value: 'seenStatus',
                sorted: false,
                direction: null,
                sortable: false
              }
            ]
          })
        } else {
          this.setState({
            crm: [],
            countCrm: 0
          })
        }
      })
      .catch()
  }

  getCrmNumber = (numberCrm) => {
    this.setState({numberCrm})
  }
  getCrmSort = (sortByCrm) => {
    this.setState({
      sortByCrm
    })
  }

  showDetails = (numId) => {
    var id = numId
    this.setState({
      modalDetails: !this.state.modalDetails
    })
    http
      .get(
        `${CRM.CRM_CONTACT_DETAIL_LIST}?contactMasterId=${id}&pageNumber=1&pageSize=100&sortBy=changedTimeStamp_desc`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('detailId', id)
          this.setState({
            detailsList: response.data.object.result,
            detailsTotal: response.data.object.countAll
          })

          this.crm(this.state.customerCode)
        } else {
          // message.error(response.data.description)
          this.setState({
            detailsList: []
          })
        }
      })
  }

  closeDetails = () => {
    this.setState({
      modalDetails: !this.state.modalDetails
    })
  }

  details = () => {
    this.setState({
      modalDetails: !this.state.modalDetails
    })
  }
  showEdit = (
    contactMasterId,
    contactCategoryId,
    contactDefinitionId,
    contactMediaId,
    contactPriorityId,
    contactStatusId,
    contactSubjectId,
    comment,
    response,
    action
  ) => {
    this.setState({
      editModal: !this.state.editModal,
      contactCategoryId,
      contactDefinitionId,
      contactMediaId,
      contactPriorityId,
      contactStatusId,
      contactSubjectId,
      comment,
      response,
      action
    })
    sessionStorage.setItem('contactMasterId', contactMasterId)

    http.get(`${CRM.CRM_CONTACT_SUBJECT_LIST}?contactCategoryId=${contactCategoryId}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          editableSubjectList: response.data.object
        })
      } else {
        this.setState({
          editableSubjectList: []
        })
      }
    })

    http.get(`crm/contact/status/list`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          statusList: response.data.object,
          editableStatusList: response.data.object
        })
      } else {
        this.setState({
          statusList: [],
          editableStatusList: []
        })
      }
    })

    http.get(`${CRM.CRM_CONTACT_DEFINITION_LIST}?contactSubjectId=${contactSubjectId}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          editableDefinitionList: response.data.object
        })
      } else {
        this.setState({
          editableDefinitionList: []
        })
      }
    })

    http.get(`${CRM.CRM_CONTACT_MEDIA_LIST}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          mediaList: response.data.object,
          editableMediaList: response.data.object
        })
      } else {
        this.setState({
          mediaList: [],
          editableMediaList: []
        })
      }
    })

    http.get(`${CRM.CRM_CONTACT_PRIORIRT_LIST}`, {}).then((response) => {
      // alert(JSON.stringify(response))
      if (response.data.error == null) {
        this.setState({
          priorityList: response.data.object,
          editablePriorityList: response.data.object
        })
      } else {
        this.setState({
          priorityList: [],
          editablePriorityList: []
        })
      }
    })

    http.get(`${CRM.CRM_CONTACT_CATEGORY_LIST}`, {}).then((response) => {
      // alert(JSON.stringify(response.data))
      if (response.data.error == null) {
        this.setState({
          categoryList: response.data.object,
          editableCategoryList: response.data.object
        })
      } else {
        this.setState({
          categoryList: [],
          editableCategoryList: []
        })
      }
    })
  }

  editToogle = () => {
    this.setState({
      editModal: !this.state.editModal
    })
  }
  closeEdit = () => {
    this.setState({
      editModal: !this.state.editModal
    })
  }

  EditOk = () => {
    var contactMasterId = sessionStorage.getItem('contactMasterId')
    var editMedia = document.getElementById('editMedia').value
    var editCat = document.getElementById('editCat').value
    var editSub = document.getElementById('editSub').value
    var editDef = document.getElementById('editDef').value
    var editPri = document.getElementById('editPri').value
    var editResponse = document.getElementById('editRes').value
    var editCm = document.getElementById('editCm').value
    var editAction = document.getElementById('editAction').value
    var status = document.getElementById('editStatus').value
    if (editCm == '') {
      message.error('دیدگاه را وارد کنید')
    } else {
      let data = {
        contactMasterId,
        contactMediaId: editMedia,
        contactCategoryId: editCat,
        contactSubjectId: editSub,
        contactDefinitionId: editDef,
        contactPriorityId: editPri,
        contactComment: editCm,
        contactStatusId: status,
        contactResponse: editResponse,
        contactAction: editAction
      }

      http.post(`${CRM.CRM_CONTACT_MASTER_DETAIL_UPDATE}`, data, {}).then((response) => {
        if (response.data.description == null) {
          message.success('دیدگاه با موفقیت ویرایش شد')
          this.setState({
            editModal: !this.state.editModal
          })
          this.crm(this.state.customerCode)
        } else {
          this.setState({
            editModal: !this.state.editModal
          })
          // message.error(response.data.description)
        }
      })
    }
  }

  showComment = (comment, response, selectedRow) => {
    var selectedArray = []
    selectedArray.push(this.state.detailsList[selectedRow])

    this.setState({
      showComment: comment,
      showResponse: response,
      modalDetails: !this.state.modalDetails,
      modalComment: !this.state.modalConfirm,
      selectedRow: selectedArray
    })
  }

  toggleComment = () => {
    this.setState({
      showComment: '',
      showResponse: '',
      modalDetails: true,
      modalComment: false,
      selectedRow: []
    })
  }
  closeComment = () => {
    this.setState({
      showComment: '',
      showResponse: '',
      modalDetails: true,
      modalComment: false,
      selectedRow: []
    })
  }

  changeEditableCat = (e) => {
    let value = e.target.value
    http.get(`${CRM.CRM_CONTACT_SUBJECT_LIST}?contactCategoryId=${value}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          editableSubjectList: response.data.object
        })
      } else {
        this.setState({
          editableSubjectList: []
        })
      }
    })
  }
  changeEditableSub = (e) => {
    let value = e.target.value

    http.get(`${CRM.CRM_CONTACT_DEFINITION_LIST}?contactSubjectId=${value}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          editableDefinitionList: response.data.object
        })
      } else {
        this.setState({
          editableDefinitionList: []
        })
      }
    })
  }

  filter() {
    let customerCode = this.state.customerCode
    if (customerCode === '') {
      message.error('کد مشتری مورد نظر وارد شود')
    } else {
      this.setState(
        {
          sizeEditedAddress: 10,
          numberEditedAddress: 1,
          sizeTransaction: 10,
          numberTransaction: 1,
          sizeDeliveryPack: 10,
          numberDeliveryPack: 1,
          sizeInvoice: 10,
          numberInvoice: 1,
          sizeCrm: 10,
          numberCrm: 1,
          loading: true,
          filteredProfile: false,
          filteredCrm: false,
          filteredInvoice: false,
          filteredAddress: false,
          filteredPurchase: false,
          filteredTransaction: false,
          filteredDeliveryPack: false,
          CrmcustomerCode: this.state.customerCode
        },
        () => {
          if (this.state.content === 'overView') {
            Promise.all([this.getProfile(customerCode)]).then((res) => {
              this.setState({
                loading: false,
                filtered: true,
                filteredProfile: true
              })
            })
          } else if (this.state.content === 'crm') {
            Promise.all([this.crm(customerCode)]).then((res) => {
              this.setState({
                loading: false,
                filtered: true,
                filteredCrm: true
              })
            })
          } else if (this.state.content === 'invoice') {
            Promise.all([this.getInvoice(customerCode)]).then((res) => {
              this.setState({
                loading: false,
                filtered: true,
                filteredInvoice: true
              })
            })
          } else if (this.state.content === 'addressess') {
            Promise.all([this.getEditedAddress(customerCode)]).then((res) => {
              this.setState({
                loading: false,
                filtered: true,
                filteredAddress: true
              })
            })
          } else if (this.state.content === 'purchase') {
            Promise.all([this.getPurchasedProduct(customerCode)]).then((res) => {
              this.setState({
                loading: false,
                filtered: true,
                filteredPurchase: true
              })
            })
          } else if (this.state.content === 'transaction') {
            Promise.all([this.getTransactionCustomer(customerCode)]).then((res) => {
              this.setState({
                loading: false,
                filtered: true,
                filteredTransaction: true
              })
            })
          } else if (this.state.content === 'deliveryPack') {
            Promise.all([this.getDeliveryPack(customerCode)]).then((res) => {
              this.setState({
                loading: false,
                filtered: true,
                filteredDeliveryPack: true
              })
            })
          }
        }
      )
    }
  }

  showRelatedContent = (content) => {
    let {customerCode} = this.state
    this.setState(
      {
        content,
        loading: true
      },
      () => {
        if (content === 'overView') {
          if (!this.state.filteredProfile) {
            this.getProfile(customerCode).then(() => {
              this.setState({
                loading: false,
                filteredProfile: true
              })
            })
          } else {
            this.setState({
              loading: false
            })
          }
        } else if (content === 'crm') {
          if (!this.state.filteredCrm) {
            this.crm(customerCode).then(() => {
              this.setState({
                loading: false,
                filteredCrm: true
              })
            })
          } else {
            this.setState({
              loading: false
            })
          }
        } else if (content === 'invoice') {
          if (!this.state.filteredInvoice) {
            this.getInvoice(customerCode).then(() => {
              this.setState({
                loading: false,
                filteredInvoice: true
              })
            })
          } else {
            this.setState({
              loading: false
            })
          }
        } else if (content === 'addressess') {
          if (!this.state.filteredAddress) {
            this.getEditedAddress(customerCode).then(() => {
              this.setState({
                loading: false,
                filteredAddress: true
              })
            })
          } else {
            this.setState({
              loading: false
            })
          }
        } else if (content === 'purchase') {
          if (!this.state.filteredPurchase) {
            this.getPurchasedProduct(customerCode).then(() => {
              this.setState({
                loading: false,
                filteredPurchase: true
              })
            })
          } else {
            this.setState({
              loading: false
            })
          }
        } else if (content === 'transaction') {
          if (!this.state.filteredTransaction) {
            this.getTransactionCustomer(customerCode).then(() => {
              this.setState({
                loading: false,
                filteredTransaction: true
              })
            })
          } else {
            this.setState({
              loading: false
            })
          }
        } else if (content === 'deliveryPack') {
          if (!this.state.filteredDeliveryPack) {
            this.getDeliveryPack(customerCode).then(() => {
              this.setState({
                loading: false,
                filteredDeliveryPack: true
              })
            })
          } else {
            this.setState({
              loading: false
            })
          }
        }
      }
    )
  }

  getSingleCustomerCode = (customerCode) => {
    this.setState({
      customerCode
    })
  }

  changeFieldConfirm(e) {
    const target = e.target
    const value = target.type == 'checkbox' ? target.checked : target.value
    const name = target.name
    this.setState({
      [name]: value
    })
  }

  setActiveTab = (index) => {
    this.setState({
      activeTab: index
    })
  }

  callToCustomer = (mobile, buyerName) => {
    if (mobile === '') {
      message.error('شماره موبایل مورد نظر وجود ندارد')
    } else {
      this.setState({
        showMobileCallModal: true
      })
      let internalPhone = '725'
      voip(mobile, buyerName)
        .then((res) => {
          if (res) {
            message.success('تماس برقرار شد لطفا منتظر پاسخ بمانید')
          } else {
            console.log('error')
            this.setState({
              showMobileCallModal: false
            })
          }
        })
        .catch((err) => {
          message.error(err)
          this.setState({
            showMobileCallModal: false
          })
        })
    }
  }

  render() {
    const modalStyle = {
      maxWidth: '96%',
      height: '300px'
    }
    let {listEditedAddress, listTransaction, listInvoice, crm, noBuy, deliveryPack, rfml} = this.state

    let stepData = [
      {
        title: 'نگاه اجمالی',
        value: 'overView',
        content: (
          <>
            <div className="card mt-1 p-2">
              <div className="container-fluid p-0">
                <div className="card-body p-0">
                  <div className="row">
                    <div className="col-sm-12 col-md-3 mt-sm-2 mt-md-0">
                      <h5 className="font-weight-bold">
                        <span className="text-dark">نام و نام خانوادگی :‌ </span>
                        <span className="text-muted">
                          {this.state.profile.firstName + ' ' + this.state.profile.lastName}
                        </span>
                      </h5>
                    </div>
                    {/*<div className='col-sm-12 col-md-3 mt-sm-2 mt-md-0'>*/}
                    {/*    <h5 className='font-weight-bold'>*/}
                    {/*        <span className='text-dark'>کد ملی :‌ </span>*/}
                    {/*        <span className='text-muted'>{this.state.profile.nationalId}</span>*/}
                    {/*    </h5>*/}
                    {/*</div>*/}
                    <div className="col-sm-12 col-md-3 mt-sm-2 mt-md-0">
                      <h5 className="font-weight-bold">
                        <span className="text-dark">تاریخ ثبت نام :‌ </span>
                        <span className="text-muted">
                          {jMoment(this.state.profile.registerDate).format('jYYYY/jMM/jDD')}
                        </span>
                      </h5>
                    </div>
                    <div className="col-sm-12 col-md-3 mt-sm-2 mt-md-0">
                      <h5 className="font-weight-bold">
                        <span className="text-dark">جنسیت :‌ </span>
                        <span className="text-muted">{genderType(this.state.profile.gender)}</span>
                      </h5>
                    </div>
                    <div className="col-sm-12 col-md-3 mt-2">
                      <h5 className="font-weight-bold">
                        <span className="text-dark">شماره موبایل :‌ </span>
                        <span className="text-muted">
                          {!this.state.profile.mobile ? '-' : this.state.profile.mobile.replace(/\+98/g, '0')}
                        </span>
                      </h5>
                    </div>
                    <div className="col-sm-12 col-md-3 mt-2">
                      <h5 className="font-weight-bold mb-0">
                        <span className="text-dark">تاریخ تولد :‌ </span>
                        <span className="text-muted">
                          {this.state.profile.birthDate &&
                            this.state.profile.birthDate !== null &&
                            jMoment(this.state.profile.birthDate).format('jYYYY/jMM/jDD')}
                        </span>
                      </h5>
                    </div>
                    <div className="col-sm-12 col-md-3 mt-2">
                      <h5 className="font-weight-bold mb-0">
                        <span className="text-dark">تلفن :‌ </span>
                        <span className="text-muted">{this.state.profile.telephone}</span>
                      </h5>
                    </div>
                    {/*<div className='col-sm-12 col-md-3 mt-2'>*/}
                    {/*    <h5 className='font-weight-bold mb-0'>*/}
                    {/*        <span className='text-dark'>نام کاربری :‌ </span>*/}
                    {/*        <span*/}
                    {/*            className='text-muted'>{(!this.state.profile.username ? '-' : this.state.profile.username.replace(/\+98/g, '0'))}</span>*/}
                    {/*    </h5>*/}
                    {/*</div>*/}
                    <div className="col-sm-12 col-md-3 mt-2">
                      <h5 className="font-weight-bold mb-0">
                        <span className="text-dark">کد مشتری :‌ </span>
                        <span className="text-muted">{this.state.profile.userCode}</span>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card mt-1 p-2">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td />
                    <td>تعداد کل</td>
                    <td>مبلغ کل</td>
                    <td>تخفیف</td>
                    {/*<td>تخفیف تامین کننده</td>*/}
                    <td>مبلغ قابل پرداخت</td>
                    <td>تعداد اقلام هر سفارش</td>
                    <td>میانگین تعداد اقلام هر سفارش</td>
                    <td>آخرین تاریخ</td>
                    <td>فاصله آخرین سفارش تا کنون (روز)</td>
                    <td>تاریخ اولین سفارش</td>
                    <td>فاصله اولین سفارش بعد از ثبت نام (روز)</td>
                    <td>میانگین فاصله سفارشات (روز)</td>
                  </tr>
                  <tr>
                    <td className="font-weight-bold text-danger">کنسل شده</td>
                    <td>{this.state.customerCancel && this.state.customerCancel.count}</td>
                    <td>
                      {this.state.customerCancel &&
                        accounting.formatMoney(this.state.customerCancel.totalAmount, '', ',')}{' '}
                      ریال
                    </td>
                    <td>
                      {this.state.customerCancel &&
                        accounting.formatMoney(
                          this.state.customerCancel.websiteDiscountAmount +
                            this.state.customerCancel.providerDiscountAmount,
                          '',
                          ','
                        )}{' '}
                      ریال
                    </td>

                    {/*<td>{this.state.customerCancel && accounting.formatMoney(this.state.customerCancel.websiteDiscountAmount, '', ',')} ریال</td>*/}
                    {/*<td>{this.state.customerCancel && accounting.formatMoney(this.state.customerCancel.providerDiscountAmount, '', ',')} ریال</td>*/}
                    <td>
                      {this.state.customerCancel &&
                        accounting.formatMoney(this.state.customerCancel.payableAmount, '', ',')}{' '}
                      ریال
                    </td>
                    <td>{this.state.customerCancel && this.state.customerCancel.itemCount}</td>
                    <td>{this.state.customerCancel && this.state.customerCancel.itemCountAverage}</td>
                    <td>
                      {this.state.customerCancel &&
                        this.state.customerCancel.lastDate !== null &&
                        jMoment(this.state.customerCancel.lastDate).format('jYYYY/jMM/jDD')}
                    </td>
                    <td>{this.state.customerCancel && this.state.customerCancel.distanceLastPurchaseToNow}</td>
                    <td>
                      {this.state.customerCancel &&
                        this.state.customerCancel.firstDate !== null &&
                        jMoment(this.state.customerCancel.firstDate).format('jYYYY/jMM/jDD')}
                    </td>
                    <td>{this.state.customerCancel && this.state.customerCancel.distanceRegisterToFirstPurchase}</td>
                    <td>{this.state.customerCancel && this.state.customerCancel.dateDistanceAverage}</td>
                  </tr>
                  <tr>
                    <td className="font-weight-bold">جاری</td>
                    <td>{this.state.customerCurrent && this.state.customerCurrent.count}</td>
                    <td>
                      {this.state.customerCurrent &&
                        accounting.formatMoney(this.state.customerCurrent.totalAmount, '', ',')}{' '}
                      ریال
                    </td>
                    <td>
                      {this.state.customerCurrent &&
                        accounting.formatMoney(
                          this.state.customerCurrent.websiteDiscountAmount +
                            this.state.customerCurrent.providerDiscountAmount,
                          '',
                          ','
                        )}{' '}
                      ریال
                    </td>

                    {/*<td>{this.state.customerCurrent && accounting.formatMoney(this.state.customerCurrent.websiteDiscountAmount, '', ',')} ریال</td>*/}
                    {/*<td>{this.state.customerCurrent && accounting.formatMoney(this.state.customerCurrent.providerDiscountAmount, '', ',')} ریال</td>*/}
                    <td>
                      {this.state.customerCurrent &&
                        accounting.formatMoney(this.state.customerCurrent.payableAmount, '', ',')}{' '}
                      ریال
                    </td>
                    <td>{this.state.customerCurrent && this.state.customerCurrent.itemCount}</td>
                    <td>{this.state.customerCurrent && this.state.customerCurrent.itemCountAverage}</td>
                    <td>
                      {this.state.customerCurrent &&
                        this.state.customerCurrent.lastDate !== null &&
                        jMoment(this.state.customerCurrent.lastDate).format('jYYYY/jMM/jDD')}
                    </td>
                    <td>{this.state.customerCurrent && this.state.customerCurrent.distanceLastPurchaseToNow}</td>
                    <td>
                      {this.state.customerCurrent &&
                        this.state.customerCurrent.firstDate !== null &&
                        jMoment(this.state.customerCurrent.firstDate).format('jYYYY/jMM/jDD')}
                    </td>
                    <td>{this.state.customerCurrent && this.state.customerCurrent.distanceRegisterToFirstPurchase}</td>
                    <td>{this.state.customerCurrent && this.state.customerCurrent.dateDistanceAverage}</td>
                  </tr>
                  <tr>
                    <td className="font-weight-bold text-success">خرید موفق</td>
                    <td>{this.state.customerPurchase && this.state.customerPurchase.count}</td>
                    <td>
                      {this.state.customerPurchase &&
                        accounting.formatMoney(this.state.customerPurchase.totalAmount, '', ',')}{' '}
                      ریال
                    </td>
                    <td>
                      {this.state.customerPurchase &&
                        accounting.formatMoney(
                          this.state.customerPurchase.websiteDiscountAmount +
                            this.state.customerPurchase.providerDiscountAmount,
                          '',
                          ','
                        )}{' '}
                      ریال
                    </td>

                    {/*<td>{this.state.customerPurchase && accounting.formatMoney(this.state.customerPurchase.websiteDiscountAmount, '', ',')} ریال</td>*/}
                    {/*<td>{this.state.customerPurchase && accounting.formatMoney(this.state.customerPurchase.providerDiscountAmount, '', ',')} ریال</td>*/}
                    <td>
                      {this.state.customerPurchase &&
                        accounting.formatMoney(this.state.customerPurchase.payableAmount, '', ',')}{' '}
                      ریال
                    </td>
                    <td>{this.state.customerPurchase && this.state.customerPurchase.itemCount}</td>
                    <td>{this.state.customerPurchase && this.state.customerPurchase.itemCountAverage}</td>
                    <td>
                      {this.state.customerPurchase &&
                        this.state.customerPurchase.lastDate !== null &&
                        jMoment(this.state.customerPurchase.lastDate).format('jYYYY/jMM/jDD')}
                    </td>
                    <td>{this.state.customerPurchase && this.state.customerPurchase.distanceLastPurchaseToNow}</td>
                    <td>
                      {this.state.customerPurchase &&
                        this.state.customerPurchase.firstDate !== null &&
                        jMoment(this.state.customerPurchase.firstDate).format('jYYYY/jMM/jDD')}
                    </td>
                    <td>
                      {this.state.customerPurchase && this.state.customerPurchase.distanceRegisterToFirstPurchase}
                    </td>
                    <td>{this.state.customerPurchase && this.state.customerPurchase.dateDistanceAverage}</td>
                  </tr>
                  <tr style={{background: '#dedede'}}>
                    <td className="font-weight-bold">کل سفارشات</td>
                    <td>{this.state.customerInvoice && this.state.customerInvoice.count}</td>
                    <td>
                      {this.state.customerInvoice &&
                        accounting.formatMoney(this.state.customerInvoice.totalAmount, '', ',')}{' '}
                      ریال
                    </td>
                    <td>
                      {this.state.customerInvoice &&
                        accounting.formatMoney(
                          this.state.customerInvoice.websiteDiscountAmount +
                            this.state.customerInvoice.providerDiscountAmount,
                          '',
                          ','
                        )}{' '}
                      ریال
                    </td>
                    {/*<td>{this.state.customerInvoice && accounting.formatMoney(this.state.customerInvoice.providerDiscountAmount, '', ',')} ریال</td>*/}
                    <td>
                      {this.state.customerInvoice &&
                        accounting.formatMoney(this.state.customerInvoice.payableAmount, '', ',')}{' '}
                      ریال
                    </td>
                    <td>{this.state.customerInvoice && this.state.customerInvoice.itemCount}</td>
                    <td>{this.state.customerInvoice && this.state.customerInvoice.itemCountAverage}</td>
                    <td>
                      {this.state.customerInvoice &&
                        this.state.customerInvoice.lastDate !== null &&
                        jMoment(this.state.customerInvoice.lastDate).format('jYYYY/jMM/jDD')}
                    </td>
                    <td>{this.state.customerInvoice && this.state.customerInvoice.distanceLastPurchaseToNow}</td>
                    <td>
                      {this.state.customerInvoice &&
                        this.state.customerInvoice.firstDate !== null &&
                        jMoment(this.state.customerInvoice.firstDate).format('jYYYY/jMM/jDD')}
                    </td>
                    <td>{this.state.customerInvoice && this.state.customerInvoice.distanceRegisterToFirstPurchase}</td>
                    <td>{this.state.customerInvoice && this.state.customerInvoice.dateDistanceAverage}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="card mt-1 p-2">
              <h4 className="text-success mb-0 font-weight-bold">خرید موفق</h4>
              <table className="baseTable mt-2">
                <tbody>
                  <tr className="firstRow">
                    <td />
                    <td>تعداد کالا</td>
                    <td>تعداد فاکتور</td>
                    <td>درصد کالا</td>
                    <td>درصد فاکتور</td>
                    <td>مقدار تخفیف</td>
                  </tr>
                  <tr>
                    <td className="font-weight-bold text-info">جشنواره</td>
                    <td>{this.state.festival && this.state.festival.itemCount}</td>
                    <td>{this.state.festival && this.state.festival.purchaseCount}</td>
                    <td>{this.state.festival && this.state.festival.itemCountPercent} %</td>
                    <td>{this.state.festival && this.state.festival.purchaseCountPercent} %</td>
                    <td>{this.state.festival && accounting.formatMoney(this.state.festival.amount, '', ',')} ریال</td>
                  </tr>
                  <tr>
                    <td className="font-weight-bold text-danger">پیشنهاد ویژه</td>
                    <td>{this.state.deal && this.state.deal.itemCount}</td>
                    <td>{this.state.deal && this.state.deal.purchaseCount}</td>
                    <td>{this.state.deal && this.state.deal.itemCountPercent} %</td>
                    <td>{this.state.deal && this.state.deal.purchaseCountPercent} %</td>
                    <td>{this.state.deal && accounting.formatMoney(this.state.deal.amount, '', ',')} ریال</td>
                  </tr>
                </tbody>
              </table>
              <div className="mt-2 p-2">
                <div className="container-fluid p-0">
                  <div className="card-body p-0">
                    <div className="row">
                      <div className="col-sm-12 col-md-3 mt-sm-2 mt-md-0">
                        <h6 className="font-weight-bold mb-md-0">
                          <span className="text-dark">اعتبار هدیه کل :‌ </span>
                          <span className="text-muted">
                            {this.state.allGiftAmount !== null &&
                              accounting.formatMoney(this.state.allGiftAmount, '', ',')}{' '}
                            ریال
                          </span>
                        </h6>
                      </div>
                      <div className="col-sm-12 col-md-3 mt-sm-2 mt-md-0">
                        <h6 className="font-weight-bold mb-md-0">
                          <span className="text-dark">اعتبار هدیه استفاده شده :‌ </span>
                          <span className="text-muted">
                            {this.state.usedGiftAmount !== null &&
                              accounting.formatMoney(this.state.usedGiftAmount, '', ',')}{' '}
                            ریال
                          </span>
                        </h6>
                      </div>
                      <div className="col-sm-12 col-md-3 mt-sm-2 mt-md-0">
                        <h6 className="font-weight-bold mb-md-0">
                          <span className="text-dark">تعداد کالاهای کنسل شده :‌ </span>
                          <span className="text-muted">{this.state.notSuppliedItemCount}</span>
                        </h6>
                      </div>
                      <div className="col-sm-12 col-md-3 mt-sm-2 mt-md-0">
                        <h6 className="font-weight-bold mb-md-0">
                          <span className="text-dark">درصد کالاهای کنسل شده :‌ </span>
                          <span className="text-muted">{this.state.notSuppliedItemPercent}</span>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )
      },
      {
        title: 'ارتباط با مشتری',
        value: 'crm',
        content: (
          <>
            <a
              href={`/CRM/add?customerCode=${this.state.CrmcustomerCode}`}
              className="my-2"
              id="addBaseInfo"
              style={{display: 'inline-block'}}
              target="_blank"
            >
              افزودن دیدگاه مشتری
            </a>
            {this.state.crm.length > 0 ? (
              <>
                <table className="baseTable">
                  <tbody>
                    <Sort data={this.state.crmSortData} getSort={this.getCrmSort} />

                    {this.state.crm.map((crm, index) => (
                      <tr key={index}>
                        <td>{(this.state.numberCrm - 1) * this.state.sizeCrm + index + 1}</td>
                        <td>{crm.firstName + ' ' + crm.lastName}</td>
                        <td>{crm.gender == null ? '-' : crm.gender == false ? 'زن' : 'مرد'}</td>
                        <td>{crm.customerCode}</td>
                        <td>
                          <button
                            title="تماس"
                            className="btn btn-sm btn-success text-dark font-weight-bold"
                            onClick={() =>
                              this.callToCustomer(
                                crm.mobile == null ? '' : crm.mobile.replace(/\+98/g, '0'),
                                crm.firstName + ' ' + crm.lastName
                              )
                            }
                          >
                            <span className="text-dark font-weight-bold" style={{color: '#000'}}>
                              {crm.mobile == null ? '-' : crm.mobile.replace(/\+98/g, '0')}
                            </span>
                          </button>
                        </td>
                        <td>{crm.invoiceId}</td>
                        <td>{crm.invoiceNum}</td>
                        <td>{jMoment(crm.registrationTime).format('jYYYY/jMM/jDD HH:mm')}</td>
                        <td>{crm.operatorName}</td>
                        <td>{jMoment(crm.lastChangeTimeStamp).format('jYYYY/jMM/jDD HH:mm')}</td>
                        <td style={{background: crm.contactStatusColor}}>
                          <span className="font-weight-bold" style={{color: '#fff'}}>
                            {crm.contactStatusName}
                          </span>
                        </td>
                        <td>
                          <button className="details" onClick={() => this.showDetails(crm.contactMasterId)}>
                            <img src={require('../../image/details.svg')} alt="" />
                          </button>
                        </td>

                        <td>
                          <button
                            className="details"
                            onClick={() =>
                              this.showEdit(
                                crm.contactMasterId,
                                crm.contactCategoryId,
                                crm.contactDefinitionId,
                                crm.contactMediaId,
                                crm.contactPriorityId,
                                crm.contactStatusId,
                                crm.contactSubjectId,
                                crm.comment,
                                crm.response,
                                crm.action
                              )
                            }
                          >
                            <img src={require('../../image/editDriver.svg')} alt="" />
                          </button>
                        </td>
                        <td>
                          {crm.seen ? (
                            <img src={require('../../image/read.svg')} alt="read" title={'مشاهده شده'} />
                          ) : (
                            <img src={require('../../image/unread.svg')} alt="unread" title={'مشاهده نشده'} />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="mt-2 d-flex flex-row">
                  <Pageing
                    defaultCurrent={1}
                    getPage={this.getCrmNumber}
                    pageSize={this.state.sizeCrm}
                    currentPage={this.state.numberCrm}
                    total={this.state.countCrm}
                  />
                  <select
                    onChange={(e) => this.setState({sizeCrm: e.target.value})}
                    className="form-control"
                    style={{height: '32px', width: '70px'}}
                  >
                    <option selected={this.state.sizeCrm == 10 ? true : false} value={10}>
                      10
                    </option>
                    <option selected={this.state.sizeCrm == 20 ? true : false} value={20}>
                      20
                    </option>
                    <option selected={this.state.sizeCrm == 50 ? true : false} value={50}>
                      50
                    </option>
                    <option selected={this.state.sizeCrm == 100 ? true : false} value={100}>
                      100
                    </option>
                  </select>
                </div>
              </>
            ) : (
              <p className="text-danger text-center font-weight-bold my-2">هیچ نتیجه ای یافت نشد</p>
            )}
          </>
        )
      },
      {
        title: 'سفارشات',
        value: 'invoice',
        content: (
          <>
            {this.state.listInvoice.length > 0 ? (
              <>
                <table className="baseTable">
                  <tbody>
                    <Sort data={this.state.sortInvoiceData} getSort={this.getSortInvoice} />

                    {this.state.listInvoice.map((items, index) => (
                      <tr key={index}>
                        <td>{(this.state.numberInvoice - 1) * this.state.sizeInvoice + index + 1}</td>

                        <td>
                          <a href={orderInfo({orderId: items.invoice.invoiceNum})} target={'_blank'}>
                            {items.invoice.invoiceNum}
                          </a>
                        </td>
                        <td>{items.invoice.recipientName}</td>
                        <td className="mobileTD">
                          {items.invoice.mobile == null ? '-' : items.invoice.mobile.replace(/\+98/g, '0')}
                        </td>
                        <td className="smallPhoto">
                          {items.invoice.confirmed ? (
                            <img src={require('../../image/confirm.svg')} />
                          ) : (
                            <img src={require('../../image/ignor.svg')} />
                          )}
                        </td>
                        <td className="smallPhoto">
                          {items.invoice.paid ? (
                            <img src={require('../../image/confirm.svg')} />
                          ) : (
                            <img src={require('../../image/ignor.svg')} />
                          )}
                        </td>
                        <td>
                          {items.invoice.registerDate == null
                            ? '-'
                            : jMoment(items.invoice.registerDate).format('jYYYY/jMM/jDD HH:mm')}
                        </td>
                        <td>
                          {items.invoice.confirmDate == null
                            ? '-'
                            : jMoment(items.invoice.confirmDate).format('jYYYY/jMM/jDD HH:mm')}
                        </td>
                        <td>{items.invoice.payOnDelivery ? 'بله' : 'خیر'}</td>
                        <td className="priceCell">
                          {items.invoice.totalAmount ? accounting.formatMoney(items.invoice.totalAmount, '', ',') : ''}
                        </td>
                        <td className="priceCell">
                          {items.invoice.websiteDiscountAmount
                            ? accounting.formatMoney(items.invoice.websiteDiscountAmount, '', ',')
                            : ''}
                        </td>
                        <td className="priceCell">
                          {items.invoice.providerDiscountAmount
                            ? accounting.formatMoney(items.invoice.providerDiscountAmount, '', ',')
                            : ''}
                        </td>
                        <td className="priceCell">
                          {items.invoice.payableAmount
                            ? accounting.formatMoney(items.invoice.payableAmount, '', ',')
                            : ''}
                        </td>

                        <td>{items.invoice.address}</td>
                        <td>
                          <Link
                            to={`/detailsInvoice/${items.invoice.invoiceId}/${items.invoice.invoiceNum}/${
                              items.invoice.buyerName
                            }`}
                            target="_blank"
                          >
                            <img src={require('../../image/details.svg')} alt="" />
                          </Link>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan={9}>مجموع</td>
                      <td className="priceCell">
                        {accounting.formatMoney(this.state.aggregationInvoice.totalAmount, '', ',')}
                      </td>
                      <td className="priceCell">
                        {accounting.formatMoney(this.state.aggregationInvoice.websiteDiscountAmount, '', ',')}
                      </td>
                      <td className="priceCell">
                        {accounting.formatMoney(this.state.aggregationInvoice.providerDiscountAmount, '', ',')}
                      </td>
                      <td className="priceCell">
                        {accounting.formatMoney(this.state.aggregationInvoice.payableAmount, '', ',')}
                      </td>
                      <td colSpan={2} />
                    </tr>
                  </tbody>
                </table>
                <div className="mt-2 d-flex flex-row">
                  <Pageing
                    defaultCurrent={1}
                    getPage={this.getPageNumberInvoice}
                    pageSize={this.state.sizeInvoice}
                    currentPage={this.state.numberInvoice}
                    total={this.state.countAllInvoice}
                  />
                  <select
                    onChange={(e) => this.setState({sizeInvoice: e.target.value})}
                    className="form-control"
                    style={{height: '32px', width: '70px'}}
                  >
                    <option selected={this.state.sizeInvoice == 10 ? true : false} value={10}>
                      10
                    </option>
                    <option selected={this.state.sizeInvoice == 20 ? true : false} value={20}>
                      20
                    </option>
                    <option selected={this.state.sizeInvoice == 50 ? true : false} value={50}>
                      50
                    </option>
                    <option selected={this.state.sizeInvoice == 100 ? true : false} value={100}>
                      100
                    </option>
                  </select>
                </div>
              </>
            ) : (
              <p className="text-danger text-center font-weight-bold my-2">هیچ نتیجه ای یافت نشد</p>
            )}
          </>
        )
      },
      {
        title: 'آدرس های ارسال شده',
        value: 'addressess',
        content: (
          <>
            {this.state.listEditedAddress.length > 0 ? (
              <>
                <table className="baseTable">
                  <tbody>
                    <Sort data={this.state.sortEditedAddressData} getSort={this.getSortEditedAddress} />

                    {this.state.listEditedAddress.map((item, index) => (
                      <tr key={index}>
                        <td>{(this.state.numberEditedAddress - 1) * this.state.sizeEditedAddress + index + 1}</td>
                        <td>{item.address}</td>
                        <td>{item.addressCount}</td>
                        {/*<td>{jMoment(edited.editionTime).format('jYYYY/jMM/jDD HH:mm')}</td>*/}
                        {/*<td>{edited.invoiceId}</td>*/}
                        {/*<td>{edited.recipientName}</td>*/}
                        {/*<td>{edited.address}</td>*/}
                        {/*<td>{edited.customer.username}</td>*/}
                        {/*<td>{edited.customer.userCode}</td>*/}
                        {/*<td>{edited.editor === null ? '-' : edited.editor.name}</td>*/}
                        {/*<td>{edited.operator === null ? '-' : edited.operator.name}</td>*/}
                        {/*<td>{edited.confirmTime === null ? '-' : jMoment(edited.confirmTime).format('jYY/jMM/jDD HH:mm')}</td>*/}
                        {/*<td>*/}
                        {/*    <button*/}
                        {/*        onClick={() => this.showLocationEditedAddress(edited.latitude, edited.longitude, edited.recipientName)}>*/}
                        {/*        <img src={require('../../image/loc.svg')} alt={'loc'}/>*/}
                        {/*    </button>*/}
                        {/*</td>*/}

                        {/*<td className='confirmIgnor'>*/}
                        {/*    {edited.confirmed ?*/}
                        {/*        <img src={require('../../image/confirm.svg')} alt={'confirm'}*/}
                        {/*             title={'تایید شده'}/>*/}
                        {/*        : <img src={require('../../image/ignor.svg')} alt={'ignor'}*/}
                        {/*               title='تایید نشده'/>*/}
                        {/*    }*/}
                        {/*</td>*/}

                        {/*<td>*/}
                        {/*    <button*/}
                        {/*        onClick={() => this.confirm(edited.editedAddressId, edited.recipientName)}>*/}
                        {/*        <img src={require('../../image/editDriver.svg')} alt={'loc'}/>*/}
                        {/*    </button>*/}
                        {/*</td>*/}
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="mt-2 d-flex flex-row">
                  <Pageing
                    defaultCurrent={1}
                    getPage={this.getPageNumberEditedAddress}
                    pageSize={this.state.sizeEditedAddress}
                    currentPage={this.state.numberEditedAddress}
                    total={this.state.countAllEditedAddress}
                  />
                  <select
                    onChange={(e) => this.setState({sizeEditedAddress: e.target.value})}
                    className="form-control"
                    style={{height: '32px', width: '70px'}}
                  >
                    <option selected={this.state.sizeEditedAddress == 10 ? true : false} value={10}>
                      10
                    </option>
                    <option selected={this.state.sizeEditedAddress == 20 ? true : false} value={20}>
                      20
                    </option>
                    <option selected={this.state.sizeEditedAddress == 50 ? true : false} value={50}>
                      50
                    </option>
                    <option selected={this.state.sizeEditedAddress == 100 ? true : false} value={100}>
                      100
                    </option>
                  </select>
                </div>
              </>
            ) : (
              <p className="text-danger text-center font-weight-bold my-2">هیچ نتیجه ای یافت نشد</p>
            )}
          </>
        )
      },
      {
        title: 'نوع کالاهای خریداری شده',
        value: 'purchase',
        content: (
          <>
            {this.state.listPurchased.length > 0 ? (
              <>
                <table className="baseTable">
                  <tbody>
                    <Sort data={this.state.sortDataPurchased} getSort={this.getSortPurchasedProduct} />
                    {this.state.listPurchased.map((items, index) => (
                      <tr key={index}>
                        <td>{(this.state.numberPurchased - 1) * this.state.sizePurchased + index + 1}</td>
                        <td>{items.title}</td>
                        <td>{items.itemCount}</td>
                        <td>{accounting.formatMoney(items.payableAmount, '', ',')}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="mt-2 d-flex flex-row">
                  <Pageing
                    defaultCurrent={1}
                    getPage={this.getPageNumberPurchased}
                    pageSize={this.state.sizePurchased}
                    currentPage={this.state.numberPurchased}
                    total={this.state.countAllPurchased}
                  />
                  <select
                    onChange={(e) => this.setState({sizePurchased: e.target.value})}
                    className="form-control"
                    style={{height: '32px', width: '70px'}}
                  >
                    <option selected={this.state.sizePurchased == 10 ? true : false} value={10}>
                      10
                    </option>
                    <option selected={this.state.sizePurchased == 20 ? true : false} value={20}>
                      20
                    </option>
                    <option selected={this.state.sizePurchased == 50 ? true : false} value={50}>
                      50
                    </option>
                    <option selected={this.state.sizePurchased == 100 ? true : false} value={100}>
                      100
                    </option>
                  </select>
                </div>
              </>
            ) : (
              <p className="text-danger text-center font-weight-bold my-2">هیچ نتیجه ای یافت نشد</p>
            )}
          </>
        )
      },
      {
        title: 'تراکنش ها',
        value: 'transaction',
        content: (
          <>
            {this.state.listTransaction.length > 0 ? (
              <>
                <table className="baseTable">
                  <tbody>
                    <Sort data={this.state.sortTransaction} getSort={this.getSortTransaction} />

                    {this.state.listTransaction.map((transaction, index) => (
                      <tr key={index}>
                        <td>{(this.state.numberTransaction - 1) * this.state.sizeTransaction + index + 1}</td>
                        <td>{jMoment(transaction.registerDate).format('jYY/jM/jD HH:mm')}</td>
                        <td>{transaction.transactionId}</td>
                        <td>
                          <Link target="_blank" to={`/baskets?invoiceId=${transaction.invoiceId}`}>
                            {transaction.invoiceId}
                          </Link>
                        </td>
                        <td>{transaction.paymentId}</td>
                        <td>{transaction.payment === null ? '-' : transaction.payment.methodName}</td>
                        <td>{transaction.payment === null ? '-' : transaction.payment.description}</td>
                        <td className="priceCell ltrTd">{accounting.formatMoney(transaction.amount, '', ',')}</td>
                        <td className="priceCell ltrTd">{accounting.formatMoney(transaction.amountSum, '', ',')}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="mt-2 d-flex flex-row">
                  <Pageing
                    defaultCurrent={1}
                    getPage={this.getPageNumberTransactionCustomer}
                    pageSize={this.state.sizeTransaction}
                    currentPage={this.state.numberTransaction}
                    total={this.state.countAllTransaction}
                  />
                  <select
                    onChange={(e) => this.setState({sizeTransaction: e.target.value})}
                    className="form-control"
                    style={{height: '32px', width: '70px'}}
                  >
                    <option selected={this.state.sizeTransaction == 10 ? true : false} value={10}>
                      10
                    </option>
                    <option selected={this.state.sizeTransaction == 20 ? true : false} value={20}>
                      20
                    </option>
                    <option selected={this.state.sizeTransaction == 50 ? true : false} value={50}>
                      50
                    </option>
                    <option selected={this.state.sizeTransaction == 100 ? true : false} value={100}>
                      100
                    </option>
                  </select>
                </div>
              </>
            ) : (
              <p className="text-danger text-center font-weight-bold my-2">هیچ نتیجه ای یافت نشد</p>
            )}
          </>
        )
      },
      {
        title: 'پارت تحویل',
        value: 'deliveryPack',
        content: (
          <>
            {this.state.deliveryPack.length > 0 ? (
              <>
                <table className="baseTable">
                  <tbody>
                    <Sort data={this.state.sortDataDeliveryPack} getSort={this.getSortDeliveryPack} />

                    {this.state.deliveryPack.map((items, index) => (
                      <tr key={index} style={items.colored ? {background: 'rgba(255,196,25,0.53)'} : {background: ''}}>
                        <td>{(this.state.numberDeliveryPack - 1) * this.state.sizeDeliveryPack + index + 1}</td>
                        <td>{jMoment(items.planDate).format('jYYYY/jM/jD')}</td>
                        <td>{items.planTimeFrom.substr(0, 5) + ' - ' + items.planTimeTo.substr(0, 5)}</td>
                        <td>
                          {items.dispatchDate == null ? '-' : jMoment(items.dispatchDate).format('jYYYY/jM/jD HH:mm')}
                        </td>
                        <td>{items.invoice.invoiceId}</td>
                        <td>{items.invoice.invoiceNum}</td>
                        <td>{items.invoice.buyerName}</td>

                        <td>
                          <Link target="_blank" to={`/base/users/persina/${items.customer.userCode}`}>
                            {items.customer.userCode}
                          </Link>
                        </td>

                        <td>{items.invoice.recipientName}</td>
                        <td>{items.invoice.address}</td>
                        <td className="mobileTD">
                          {items.invoice.mobile == null ? '-' : items.invoice.mobile.replace(/\+98/g, '0')}
                        </td>
                        <td>{items.invoice.paid ? 'پرداخت شده' : 'پرداخت نشده'}</td>
                        <td>{items.invoice.payOnDelivery ? 'بله' : 'خیر'}</td>
                        <td title={items.driver == null ? '-' : items.driver.mobile.replace(/\+98/g, '0')}>
                          {items.driver == null ? '-' : items.driver.name}
                        </td>
                        <td>{items.car == null ? '-' : items.car.code}</td>
                        <td className="priceCell">{accounting.formatMoney(items.totalInfo.payableAmount, '', ',')}</td>
                        <td className="priceCell">{accounting.formatMoney(items.payment.cash, '', ',')}</td>
                        <td className="priceCell">{accounting.formatMoney(items.payment.card, '', ',')}</td>
                        <td className="priceCell">{accounting.formatMoney(items.payment.prePaid, '', ',')}</td>
                        <td>{this.convertState(items.lastState, items.reAssigned)}</td>
                        <td>
                          {items.lastState == '20' && items.hasSign ? (
                            <button onClick={() => this.openSign(index)}>
                              <img
                                style={items.hasSign ? {display: 'block'} : {display: 'none'}}
                                src={require('../../image/signature.svg')}
                              />
                            </button>
                          ) : items.lastState == '20' && !items.hasSign ? (
                            ' کد'
                          ) : (
                            '-'
                          )}
                        </td>
                        <td>
                          {this.props.subDispatch ? (
                            <Link
                              to={`/itemDispatch/${items.deliveryPackId}/${items.invoice.invoiceNum}/${
                                items.invoice.invoiceId
                              }/${items.invoice.buyerName}`}
                              target="_blank"
                            >
                              <img src={require('../../image/details.svg')} alt="" />
                            </Link>
                          ) : (
                            <Link
                              to={`/itemBascket/${items.deliveryPackId}/${items.invoice.invoiceNum}/${
                                items.invoice.invoiceId
                              }/${items.invoice.buyerName}`}
                              target="_blank"
                            >
                              <img src={require('../../image/details.svg')} alt="" />
                            </Link>
                          )}
                        </td>
                        <td>
                          <Link
                            to={`/detailsPaid/${items.detailId}/${items.invoice.invoiceId}/${
                              items.driver == null ? '-' : items.driver.name
                            }`}
                            target="_blank"
                          >
                            <img
                              style={
                                items.detailId == null
                                  ? {display: 'none'}
                                  : {
                                      display: 'block',
                                      margin: 'auto'
                                    }
                              }
                              src={require('../../image/details.svg')}
                              alt=""
                            />
                          </Link>
                        </td>
                        <td>
                          <button onClick={() => this.goBeroozresan(items.invoice.invoiceId)}>
                            <img src={require('../../image/eye.svg')} />
                          </button>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan={15}>مجموع</td>
                      <td className="priceCell">
                        {accounting.formatMoney(
                          this.state.aggregationDeliveryPack.totalInfo
                            ? this.state.aggregationDeliveryPack.totalInfo.payableAmount
                            : '',
                          '',
                          ','
                        )}
                      </td>
                      <td className="priceCell">
                        {accounting.formatMoney(
                          this.state.aggregationDeliveryPack.payment
                            ? this.state.aggregationDeliveryPack.payment.cash
                            : '',
                          '',
                          ','
                        )}
                      </td>
                      <td className="priceCell">
                        {accounting.formatMoney(
                          this.state.aggregationDeliveryPack.payment
                            ? this.state.aggregationDeliveryPack.payment.card
                            : '',
                          '',
                          ','
                        )}
                      </td>
                      <td className="priceCell">
                        {accounting.formatMoney(
                          this.state.aggregationDeliveryPack.payment
                            ? this.state.aggregationDeliveryPack.payment.prePaid
                            : '',
                          '',
                          ','
                        )}
                      </td>
                      <td className="priceCell" colSpan={5} />
                    </tr>
                  </tbody>
                </table>
                <div className="mt-2 d-flex flex-row">
                  <Pageing
                    defaultCurrent={1}
                    getPage={this.getPageNumberDeliveryPack}
                    pageSize={this.state.sizeDeliveryPack}
                    currentPage={this.state.numberDeliveryPack}
                    total={this.state.countAllDeliveryPack}
                  />
                  <select
                    onChange={(e) => this.setState({sizeDeliveryPack: e.target.value})}
                    className="form-control"
                    style={{height: '32px', width: '70px'}}
                  >
                    <option selected={this.state.sizeDeliveryPack == 10 ? true : false} value={10}>
                      10
                    </option>
                    <option selected={this.state.sizeDeliveryPack == 20 ? true : false} value={20}>
                      20
                    </option>
                    <option selected={this.state.sizeDeliveryPack == 50 ? true : false} value={50}>
                      50
                    </option>
                    <option selected={this.state.sizeDeliveryPack == 100 ? true : false} value={100}>
                      100
                    </option>
                  </select>
                </div>
              </>
            ) : (
              <p className="text-danger text-center font-weight-bold my-2">هیچ نتیجه ای یافت نشد</p>
            )}
          </>
        )
      }
    ]

    return (
      <div className="rtl">
        <Loader show={this.state.loading} />

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>باشگاه مشتریان</li>
            <li>کارنامه مشتری</li>
          </ul>
          <div className="tableComponent">
            <div className="basketFilterComponent">
              <div className="filterInputs">
                {/*<div className='formComponent'>*/}
                {/*    <label>کد مشتری:</label>*/}
                {/*    <input*/}
                {/*        type='text'*/}
                {/*        className='form-control'*/}
                {/*        id='customerCode'*/}
                {/*        defaultValue={this.state.customerCode}*/}
                {/*        onChange={(e) => this.setState({customerCode: e.target.value})}*/}
                {/*        name='customerCode'/>*/}
                {/*</div>*/}
                <SearchCustomer
                  label={'کد مشتری'}
                  getSingleCustomerCode={this.getSingleCustomerCode}
                  singleResult={true}
                  getValueFromThisPage={this.state.customerCode}
                  searchLabel={'جست و جوی مشتری'}
                />
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
          </div>

          {this.state.filtered ? (
            <div className="card mt-1 p-1">
              <Tabs>
                <TabList>
                  {stepData.map((item, index) => (
                    <Tab onClick={() => this.showRelatedContent(item.value)}>{item.title}</Tab>
                  ))}
                </TabList>
                {stepData.map((item, index) => (
                  <TabPanel>{item.content}</TabPanel>
                ))}
              </Tabs>
              {/*<div className='card-header p-1'>*/}
              {/*    <ul className='p-0 m-0'>*/}
              {/*        {stepData.map((item,index)=>(*/}
              {/*            <li onClick={()=>this.setActiveTab(index)} className={index === this.state.activeTab ? 'activeTab mx-1 d-inline-block p-2' : 'deactiveTab d-inline-block mx-1 p-2'}>{item.title}</li>*/}
              {/*        ))}*/}
              {/*    </ul>*/}
              {/*</div>*/}
              {/*<div className='card-body p-1'>*/}
              {/*    {stepData[this.state.activeTab].content}*/}
              {/*</div>*/}
            </div>
          ) : null}
        </div>
        <Modal
          isOpen={this.state.modalEditedAddress}
          toggle={() => this.setState({modalEditedAddress: false})}
          size="lg"
        >
          <ModalHeader toggle={() => this.setState({modalEditedAddress: false})}>
            <p>آدرس مشتری : {this.state.recipientName}</p>
          </ModalHeader>
          <ModalBody>
            <div className="mapModalWrapper">
              <Map
                google={this.props.google}
                zoom={13}
                style={modalStyle}
                initialCenter={{
                  lat: this.state.latitude,
                  lng: this.state.longitude
                }}
              >
                <Marker
                  icon={require('../../image/requestPack.png')}
                  title={this.state.recipientName}
                  position={{lat: this.state.latitude, lng: this.state.longitude}}
                />
              </Map>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={() => this.setState({modalEditedAddress: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={this.state.confirmModal}
          toggle={() => this.setState({confirmModal: false, check: false})}
          size="sm"
        >
          <ModalHeader toggle={() => this.setState({confirmModal: false, check: false})}>
            <p>تایید آدرس مشتری : {this.state.recipientName}</p>
          </ModalHeader>
          <ModalBody>
            <p className="titleSm">
              <Checkbox name="check" tabIndex="4" onChange={this.changeFieldConfirm.bind(this)}>
                آیا از انجام عملیات مطمئن هستید؟
              </Checkbox>
            </p>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" disabled={this.state.check ? false : true} onClick={this.confirmOk}>
              تایید
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({confirmModal: false, check: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modal} toggle={() => this.setState({modal: false})} size="sm">
          <ModalHeader toggle={() => this.setState({modal: false})}>نمایش امضا</ModalHeader>
          <ModalBody>
            <div className="imageSign">
              <img src={this.state.urlSign} alt="" />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={() => this.setState({modal: false})}>
              بستن
            </Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalDetails} toggle={this.details} size="lg">
          <ModalHeader toggle={this.details}>لیست تغییرات در این دیدگاه</ModalHeader>
          <ModalBody>
            <div>
              <table
                className="baseTable"
                style={this.state.detailsList.length == '0' ? {display: 'none'} : {diplay: 'block'}}
              >
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>کاربر مشاهده کننده</td>
                    <td>زمان آخرین تغییر</td>
                    <td>دیدگاه</td>
                    <td>پاسخ اپراتور</td>
                    <td>رسانه تماس</td>
                    <td>خانواده تماس</td>
                    <td>موضوع تماس</td>
                    <td>جزییات تماس</td>
                    <td>وضعیت</td>
                    <td>مشاهده دیدگاه</td>
                  </tr>
                  {this.state.detailsList.map((change, index) => (
                    <tr key={index + 'det'}>
                      <td>{index + 1}</td>
                      <td>{change.contactPersonName}</td>
                      <td>{jMoment(change.changedTimeStamp).format('jYYYY/jMM/jDD HH:mm')}</td>
                      <td title={change.comment === null ? '-' : change.comment}>
                        {change.comment.substr(0, 5) + '....'}
                      </td>
                      <td title={change.response === null ? '-' : change.response}>
                        {change.response === null ? '-' : change.response.substr(0, 5) + '....'}
                      </td>
                      <td>{change.contactMediaName}</td>
                      <td>{change.contactCategoryName}</td>
                      <td>{change.contactSubjectName}</td>
                      <td>{change.contactDefinitionName}</td>
                      <td>{change.contactStatusName}</td>
                      <td>
                        <button
                          className="details"
                          onClick={() => this.showComment(change.comment, change.response, change.action, index)}
                        >
                          <img src={require('../../image/tap.svg')} alt="hand" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {/*<div className="paginationWrapp">*/}
              {/*  <Pageing*/}
              {/*    defaultCurrent={1}*/}
              {/*    getPage={this.getPageNumber}*/}
              {/*    pageSize={this.state.pageSize}*/}
              {/*    currentPage={this.state.pageNumber}*/}
              {/*    total={this.state.lengthProducts}*/}
              {/*  />*/}
              {/*</div>*/}
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={this.closeDetails}>
              بستن
            </button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.editModal} toggle={this.editToogle} size="lg">
          <ModalHeader toggle={this.editToogle}>ویرایش</ModalHeader>
          <ModalBody>
            <div className="editModalForm">
              <div className="crmComponent">
                <label>رسانه تماس : </label>
                <select id="editMedia" className="form-control">
                  {this.state.editableMediaList.map((media, index) => (
                    <option
                      selected={this.state.contactMediaId === media.contactMediaId ? true : false}
                      value={media.contactMediaId}
                    >
                      {media.contactMediaName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="crmComponent">
                <label>خانواده تماس : </label>
                <select id="editCat" onChange={this.changeEditableCat.bind(this)} className="form-control">
                  {this.state.editableCategoryList.map((category, index) => (
                    <option
                      selected={this.state.contactCategoryId === category.contactCategoryId ? true : false}
                      value={category.contactCategoryId}
                    >
                      {category.contactCategoryName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="crmComponent">
                <label>موضوع تماس : </label>
                <select id="editSub" onChange={this.changeEditableSub.bind(this)} className="form-control">
                  {this.state.editableSubjectList.map((subject, index) => (
                    <option
                      selected={this.state.contactSubjectId === subject.contactSubjectId ? true : false}
                      value={subject.contactSubjectId}
                    >
                      {subject.contactSubjectName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="crmComponent">
                <label>جزییات تماس : </label>
                <select id="editDef" className="form-control">
                  {this.state.editableDefinitionList.map((definition, index) => (
                    <option
                      selected={this.state.contactDefinitionId === definition.contactDefinitionId ? true : false}
                      value={this.state.contactDefinitionId}
                    >
                      {definition.contactDefinitionName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="crmComponent">
                <label>اولویت تماس : </label>
                <select id="editPri" className="form-control">
                  {this.state.editablePriorityList.map((priority, index) => (
                    <option
                      selected={this.state.contactPriorityId == priority.contactPriorityId ? true : false}
                      value={priority.contactPriorityId}
                    >
                      {priority.contactPriorityName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="crmComponent">
                <label>وضعیت : </label>
                <select className="form-control" id="editStatus">
                  {this.state.editableStatusList.map((priority, index) => (
                    <option
                      selected={Number(this.state.contactStatusId) === Number(priority.contactStatusId) ? true : false}
                      value={priority.contactStatusId}
                    >
                      {priority.contactStatusName}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="bottomCrmComponent">
              <label>دیدگاه : </label>
              <textarea id="editCm" defaultValue={this.state.comment} className="form-control" />
            </div>
            <div className="bottomCrmComponent">
              <label>پاسخ : </label>
              <textarea id="editRes" defaultValue={this.state.response} className="form-control" />
            </div>
            <div className="bottomCrmComponent">
              <label>اقدام : </label>
              <textarea id="editAction" defaultValue={this.state.action} className="form-control" />
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.EditOk}>
              ویرایش
            </button>
            <button className="cancelBtnModal" onClick={this.closeEdit}>
              بستن
            </button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalComment} toggle={this.toggleComment} size="md">
          <ModalHeader toggle={this.toggleComment}>مشاهده دیدگاه کاربر و پاسخ اپراتور</ModalHeader>
          <ModalBody>
            <div className="commentCrm">
              <div>
                <table className="baseTable">
                  <tbody>
                    <tr className="firstRow">
                      <td>زمان آخرین تغییر</td>
                      <td>رسانه تماس</td>
                      <td>خانواده تماس</td>
                      <td>موضوع تماس</td>
                      <td>جزییات تماس</td>
                      <td>وضعیت</td>
                    </tr>
                    {this.state.selectedRow.map((change, index) => (
                      <tr key={index + 'det'}>
                        <td>{jMoment(change.changedTimeStamp).format('jYYYY/jMM/jDD HH:mm')}</td>
                        <td>{change.contactMediaName}</td>
                        <td>{change.contactCategoryName}</td>
                        <td>{change.contactSubjectName}</td>
                        <td>{change.contactDefinitionName}</td>
                        <td>{change.contactStatusName}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="formComponent">
                <label>دیدگاه کاربر : </label>
                <p>{this.state.showComment}</p>
              </div>
              <div className="formComponent">
                <label>پاسخ اپراتور : </label>
                <p>{this.state.showResponse}</p>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={this.closeComment}>
              بستن
            </button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.showMobileCallModal} toggle={() => this.setState({showMobileCallModal: false})}>
          <ModalBody className="d-flex flex-column justify-content-center align-content-center align-items-center">
            <h3 className="font-weight-bold">تماس با کاربر برقرار شد</h3>
            <button className="btn btn-success" onClick={() => this.setState({showMobileCallModal: false})}>
              بستن
            </button>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

// export default GoogleApiWrapper({
//     apiKey: ('AIzaSyDh3yzsorXDyP-gAlxEGUlzmfJ6nVxizUw')
// })(ReportCustomerCard)
export default ReportCustomerCard
